import React from 'react';
import classnames from 'classnames';
import MetricsCardWrap from '@/pages/dashboard/components/MetricsCardWrap';
import { channelInfo } from '@op/components/ChannelLabel';
import { getName } from '@home/utils/common';
import { useLocal } from '@intelligence/hooks/customHook';
import './index.scss';
import TrendChart from '../TrendChart';

const GameStoreTrendCard = (props: any) => {
  const { children, className, channel, metrics, cardData, trendData, trendConfig, filter } = props;
  const {img, name} = channelInfo(channel);
  const { isEN } = useLocal();

  // 卡片数据
  const channelData = cardData?.[channel] || [];
  const metricDataMap = metrics.map((metric: { metricKey: string; }) => {
    const dataItem = channelData.find((item: { key: string; }) => item.key === metric.metricKey);
    return {
      ...metric,
      data: dataItem || null,
    };
  });

  // 趋势图数据
  const channelTrendData = trendData?.list?.find?.((item: { channel: string; }) => item.channel === channel) || [];
  // 趋势图配置
  const channelTrendConfig = trendConfig?.[channel] || [];
  // 趋势图数据格式化
  const formatted = channelTrendData?.timeline?.reduce((acc: { [x: string]: any[]; }, item: { key: string | number; }) => {
    if (!acc[item.key]) {
      acc[item.key] = [];
    }
    acc[item.key].push(item);
    return acc;
  }, {});
  // 趋势图数据组装
  const platformData = {
    list: formatted,
    timeline_of_end_time: trendData?.timeline_of_end_time,
    timeline_of_start_time: trendData?.timeline_of_start_time
  };

  return (
    <div className= {classnames('dbd-metrics-card-wrap', className)}>
      <MetricsCardWrap
        titleEn={name}
        titleCn={name}
        imgUrl={img}
      >
        <div className="dbh-game-store-v2-trend-card-metric">
          {
            metricDataMap.map(item => (
              <div
                key={name}
                className="dbh-game-store-v2-trend-card-metric-wrap"
              >
                <div className="dbh-game-store-v2-trend-card-metric-legend">
                  <div
                    className="dbh-game-store-v2-trend-card-metric-legend-color"
                    style={{ backgroundColor: item?.color }}
                  />
                  <div className="dbh-game-store-v2-trend-card-metric-legend-name">
                    {getName(isEN, item?.titleEn, item?.titleCn)}
                  </div>
                </div>
                <div className="dbh-game-store-v2-trend-card-metric-score">
                  {item.data ? (
                    <>
                      {item.data.score}
                      {item?.isPercent && "%"}
                    </>
                  ) : "-"}
                  <div className="dbh-game-store-v2-trend-card-metric-review">
                    {item.data ? item.data.review : "-"} {getName(isEN, "Reviews", "条评论")}
                  </div>
                </div>
              </div>
            ))
          }
        </div>
        <TrendChart
          platformData={platformData}
          filterParams={filter}
          seriesDataKeys={channelTrendConfig?.seriesConfig}
        />
        {children}
      </MetricsCardWrap>
    </div>
  );
};

export default GameStoreTrendCard;
